export const skillCategories = [
  {
    id: 'frontend',
    label: 'Frontend',
    skills: ['React', 'JavaScript'],
  },
  {
    id: 'backend',
    label: 'Backend',
    skills: ['Node.js', 'Express', 'Python', 'REST APIs'],
  },
  {
    id: 'cloud',
    label: 'Cloud',
    skills: ['AWS', 'CloudFront', 'S3', 'EC2', 'IAM', 'Lambda', 'CloudFormation'],
  },
  {
    id: 'devops',
    label: 'DevOps',
    skills: ['Docker', 'CI/CD', 'Jenkins'],
  },
  {
    id: 'languages',
    label: 'Programming',
    skills: ['JavaScript', 'Python', 'Java', 'Spring Boot', '.NET', 'Bash Scripting'],
  },
  {
    id: 'databases',
    label: 'Databases',
    skills: ['MongoDB', 'MySQL', 'Oracle'],
  },
  {
    id: 'tools',
    label: 'Tools',
    skills: [
      'Git',
      'GitHub',
      'Linux',
      'Jenkins',
      'Terraform',
      'Docker',
      'Burp Suite',
      'Metasploit',
      'Wireshark',
      'Cisco Packet Tracer',
      'Nmap',
    ],
  },
  {
    id: 'security',
    label: 'Security',
    skills: [
      'Web Penetration Testing',
      'Metasploit',
      'Wireshark',
      'Sessions, Tokens & Cookies',
      'Nmap',
      'IAM',
    ],
  },
]

export const learningNow = ['Kubernetes', 'Terraform', 'GCP']
